import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getChampValeursTicket, putChampValeur } from "../../api/CHAMPS/champs";

export const useChampValeursTicket = (ticketId) => {
  return useQuery({
    queryKey: ["champ-valeurs-ticket", ticketId],
    queryFn: () => getChampValeursTicket(ticketId),
    enabled: !!ticketId,
    staleTime: 2 * 60 * 1000,
  });
};

export const usePutChampValeur = (ticketId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ champId, valeur }) => putChampValeur(champId, ticketId, valeur),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["champ-valeurs-ticket", ticketId] });
    },
  });
};
